module.exports = __webpack_public_path__ + "img/8-1_07.dae40dc5.jpg";